export interface AppConfigArgument {
  id: number
  iosVersion: string
  androidVersion: string
}

export default class AppConfig {
  readonly id: number
  readonly iosVersion: string
  readonly androidVersion: string

  constructor(arg: AppConfigArgument) {
    this.id = arg.id
    this.iosVersion = arg.iosVersion
    this.androidVersion = arg.androidVersion
  }

  static fromPG(row: any): AppConfig {
    return new AppConfig({
      id: row.id,
      iosVersion: String(row.ios_version ?? ''),
      androidVersion: String(row.android_version ?? ''),
    })
  }
}
